/* eslint-disable no-prototype-builtins, no-restricted-globals, no-console, import/prefer-default-export  */
export var hasCorrectValidationFormat = function hasCorrectValidationFormat(fn, value) {
  // First paramenter needs to be a function
  if (!fn) {
    return false;
  }

  // Check if the callback has the correct type
  if (fn && typeof fn !== 'function') {
    console.warn('A valid function should be passed to "customValidation" prop. Using default validation...');
    return false;
  }
  var error = fn(value);
  var hasValidShape = error.hasOwnProperty('hasError') && error.hasOwnProperty('message');

  // Check if the callback return value has the correct shape
  if (!hasValidShape) {
    console.warn("\n        \"customValidation\" prop is returning an object with an invalid shape.\n\n        The required shape is { hasError: bool, message: string | node }\n        \n        Using default validation...\n      ");
    return false;
  }
  return true;
};
/* eslint-enable no-prototype-builtins, no-restricted-globals, no-console, import/prefer-default-export  */